import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios, acerillPublicAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/billing/v1`;

const findPlans = frequency => {
  return acerillPublicAxios
    .get(`${baseUrl}/public/plans`, {params: {product: 'custom-forms', frequency}})
    .then(response => response.data);
};

const updateSubscription = (productCode, planCode, frequency) => {
  return acerillAuthenticatedAxios
    .post(`${baseUrl}/subscriptions/shopify/step-1`, {planCode, frequency})
    .then(response => response.data || {});
};

const findSubscriptions = () => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/subscriptions`)
    .then(response => response.data);
};

const billingV1Client = {
  findPlans,
  updateSubscription,
  findSubscriptions,
};

export default billingV1Client;
